// extracted by mini-css-extract-plugin
export default {"IconWithText":"sCLYVQ97TERARc3rasnXtA==","IconOnLeft":"CzMX30fMQpdIzOlGVd9T5Q==","IconOnRight":"LthvIyvakOLAT1hV6w1Nkg==","Compact":"BVvWHlCCmRos7woGHwBVHQ=="};